import { defineComponent as _defineComponent } from 'vue'
import { StyleValue } from 'vue/types/jsx';
import ModalItem from '../ModalItem/ModalItem.vue';
import { computed, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewImgGroup',
  props: {
    imgStyle: null,
    srcGroup: null
  },
  setup(__props: any) {

const props = __props as {
  imgStyle?: StyleValue;
  srcGroup: string[];
};



const srcIndex = ref<number>(0);
const maxLength = computed(() => {
  return props.srcGroup.length;
});
function lastImg(){
    if(srcIndex.value>0){
        srcIndex.value--
    }
}
function nextImg(){
    if(srcIndex.value<maxLength.value-1){
        srcIndex.value++
    }
}

return { __sfc: true,props, srcIndex, maxLength, lastImg, nextImg, ModalItem }
}

})